import request from "../request"
//查询详细内容
export function getBannerList(data) {
    return request({
      url: '/banner/',
      method:'get',
      params:data
    })
 }


// WEBPACK FOOTER //
// ./src/api/banner.js